
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { ArrowLeft, Home } from "lucide-react";
import PageTransition from "@/components/PageTransition";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <PageTransition>
      <Navbar />
      <div className="page-container min-h-[70vh] flex items-center justify-center">
        <div className="text-center max-w-lg mx-auto py-16">
          <h1 className="text-6xl font-bold text-desert-sunset mb-4">404</h1>
          <p className="text-2xl font-medium mb-2">Page Not Found</p>
          <p className="text-foreground/70 mb-8">
            The page you're looking for doesn't seem to exist or has been moved.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button asChild className="bg-desert-gradient hover:opacity-90">
              <Link to="/" className="flex items-center">
                <Home className="mr-2 h-4 w-4" />
                Return to Home
              </Link>
            </Button>
            <Button asChild variant="outline">
              <Link to="/knowledge-base" className="flex items-center">
                <ArrowLeft className="mr-2 h-4 w-4" />
                Knowledge Base
              </Link>
            </Button>
          </div>
        </div>
      </div>
      <Footer />
    </PageTransition>
  );
};

export default NotFound;
